module.exports = __webpack_public_path__ + "media/custom/images/pocstock-contributor-collage-3-f356c7670255bac038b8ad0a909a5cb8.png";